import { useState, useEffect } from "react";
import Button from "../ui/Button";
import FormSection from "../ui/FormSection";
import FormInput from "../ui/FormInput";
import EditableTable from "../ui/EditableTable";
import SiteController from "@/network/controllers/site.controller";
import StudyController from "@/network/controllers/study.controller";
import { v4 as uuidv4 } from "uuid";
import Modal from "../ui/Modal";
import State, { STATE, CurrentStudyState } from "@state";

export default function SiteSettings({
  study = {},
  onUpdateStudy,
  siteSettings = [],
}) {
  const [sites, setSites] = useState(siteSettings);
  const [selectedMasterICF, setSelectedMasterICF] = useState("");
  const [selectedFilterICF, setSelectedFilterICF] = useState("");
  const [isDeletingSite, setIsDeletingSite] = useState(false);
  const [deleteErrorModalOpen, setDeleteErrorModalOpen] = useState(false);
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
  const [isUploadingFile, setIsUploadingFile] = useState(false);

  const [isAddingSite, setIsAddingSite] = useState(false);

  const [masterICFs, setMasterICFs] = useState(study.masterICF || []);
  const [newSite, setNewSite] = useState({
    siteName: "",
    siteAddress: "",
    masterICFVersion: "",
    siteICFLink: "",
    siteIcfFile: null,
  });

  useEffect(() => {
    if (siteSettings) {
      setSites(siteSettings);
    }
  }, [siteSettings]);

  useEffect(() => {
    if (study && study.masterICF) {
      setMasterICFs(study.masterICF);
      if (study.masterICF.length > 0) {
        const activeICF =
          study.masterICF.find((icf) => icf.isActive) || study.masterICF[0];
        setSelectedMasterICF(activeICF.id);
        setSelectedFilterICF(activeICF.id);
        setNewSite((prev) => ({
          ...prev,
          masterICFVersion: activeICF.master_icf_name,
        }));
      } else {
        setSelectedMasterICF("");
        setSelectedFilterICF("");
        setNewSite((prev) => ({
          ...prev,
          masterICFVersion: "",
        }));
      }
    } else {
      setMasterICFs([]);
      setSelectedMasterICF("");
      setSelectedFilterICF("");
      setNewSite((prev) => ({
        ...prev,
        masterICFVersion: "",
      }));
    }
  }, [study]);

  useEffect(() => {}, [masterICFs]);

  useEffect(() => {
    if (selectedFilterICF) {
      const selectedIcf = masterICFs.find(
        (icf) => icf.id === selectedFilterICF
      );
      setSelectedMasterICF(selectedFilterICF);
      setNewSite((prev) => ({
        ...prev,
        masterICFVersion: selectedIcf ? selectedIcf.master_icf_name : "",
      }));
    }
  }, [selectedFilterICF, masterICFs]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewSite((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleMasterICFChange = (e) => {
    const selectedId = e.target.value;
    setSelectedMasterICF(selectedId);
    const selectedIcf = masterICFs.find((icf) => icf.id === selectedId);
    setNewSite((prev) => ({
      ...prev,
      masterICFVersion: selectedIcf ? selectedIcf.master_icf_name : "",
    }));
    console.log(
      "handleMasterICFChange: newSite.masterICFVersion impostato a:",
      selectedIcf ? selectedIcf.master_icf_name : "N/A"
    );
  };

  const handleFilterICFChange = (e) => {
    const selectedId = e.target.value;
    setSelectedFilterICF(selectedId);
  };

  const handleFileUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setNewSite((prev) => ({
        ...prev,
        siteICFLink: file.name,
        siteIcfFile: file,
      }));
    }
  };

  //TODO:A REVOIR SI CA ENVOIE LES BONNES DONNES EN BACKEND
  const handleAddSite = async () => {
    if (!newSite.siteName || !newSite.siteAddress || !selectedMasterICF) {
      alert("Please fill in all required fields");
      return;
    }
    const masterIcf = masterICFs.find((icf) => icf.id === selectedMasterICF);
    if (!masterIcf) {
      alert("Selected Master ICF is invalid.");
      return;
    }
    if (!newSite.siteIcfFile) {
      alert("Site ICF file is required to add a site.");
      return;
    }

    setIsAddingSite(true);
    const newSiteId = uuidv4();

    const siteForState = {
      site_id: newSiteId,
      site_name: newSite.siteName,
      siteName: newSite.siteName,
      site_address: newSite.siteAddress,
      siteAddress: newSite.siteAddress,
      master_icf_version_name: masterIcf.master_icf_name,
      master_icf_id: selectedMasterICF,
      site_icf_file_name: newSite.siteICFLink,
      site_icf_id: "",
      site_icf_version_number: "1.0",
      siteIcfFile: newSite.siteIcfFile,
      integrityHash: null,
      tmpId: newSiteId,
    };

    const originalSites = [...sites];
    const originalStudyState = { ...STATE[CurrentStudyState.STUDY] };

    const sitesWithNewTempSite = [...sites, siteForState];
    setSites(sitesWithNewTempSite);
    State.setValue(CurrentStudyState.SITES, sitesWithNewTempSite);
    State.setValue(CurrentStudyState.STUDY, {
      ...STATE[CurrentStudyState.STUDY],
      sites: sitesWithNewTempSite,
    });

    let integrityHashForNewSite = null;
    let actualProtocolId = null;

    console.log(
      "=== {siteForState, study} === SiteSettings.jsx === key: 162789 ==="
    );
    console.dir({ siteForState, study }, { depth: null, colors: true });
    console.log("=================================");

    try {
      console.log("Calling queuePatchProtocolVersions to upload ICF...");
      const resp1 = await StudyController.queuePatchProtocolVersions(
        siteForState,
        study.id
      );
      console.log("=== resp1 === SiteSettings.jsx === key: 923711 ===");
      console.dir(resp1, { depth: null, colors: true });
      console.log("=================================");

      const resp2 = await StudyController.queuePatchSites(
        siteForState,
        study.id
      );

      console.log("=== resp2 === SiteSettings.jsx === key: 916365 ===");
      console.dir(resp2, { depth: null, colors: true });
      console.log("=================================");

      const uploadedFileResponse = resp1.find(
        (res) => res.success && res.fileName === newSite.siteICFLink
      );

      if (uploadedFileResponse && uploadedFileResponse.protocolId) {
        integrityHashForNewSite = uploadedFileResponse.integrityHash;
        actualProtocolId = uploadedFileResponse.protocolId;
        console.log("Retrieved integrityHash:", integrityHashForNewSite);
        console.log(
          "Retrieved actualProtocolId from upload:",
          actualProtocolId
        );

        siteForState.site_icf_id = actualProtocolId;
        console.log(
          "Assigned backend protocolId to site_icf_id in siteForState:",
          siteForState.site_icf_id
        );

        const finalSites = sitesWithNewTempSite.map((site) =>
          site.tmpId === newSiteId
            ? { ...site, site_icf_id: actualProtocolId }
            : site
        );
        setSites(finalSites);
        State.setValue(CurrentStudyState.SITES, finalSites);
        State.setValue(CurrentStudyState.STUDY, {
          ...STATE[CurrentStudyState.STUDY],
          sites: finalSites,
        });
      } else {
        throw new Error(
          "Failed to upload site ICF or retrieve integrity hash/protocol ID. Site not added."
        );
      }

      const sitePayload = {
        site_id: newSiteId,
        study_id: study.id,
        site_name: newSite.siteName,
        site_address: newSite.siteAddress,
        master_icf_id: selectedMasterICF,
        site_icf_id: actualProtocolId,
        site_icf_file_name: newSite.siteICFLink,
        integrity_hash: integrityHashForNewSite,
      };
      console.log(
        "Calling StudyController.addSiteToStudy with payload:",
        sitePayload
      );
      const response = await SiteController.addSiteToStudy(sitePayload);
      console.log("addSiteToStudy response:", response);

      if (response.success) {
        setNewSite({
          siteName: "",
          siteAddress: "",
          masterICFVersion: "",
          siteICFLink: "",
          siteIcfFile: null,
        });
        setSelectedMasterICF("");
        if (onUpdateStudy) {
          onUpdateStudy({
            ...study,
            sites: STATE[CurrentStudyState.SITES],
          });
        }
        alert("Site added successfully!");
      } else {
        throw new Error(
          `Failed to add site record to database: ${
            response.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error in handleAddSite:", error);
      alert(`An error occurred while adding the site: ${error.message}`);
      setSites(originalSites);
      State.setValue(CurrentStudyState.SITES, originalSites);
      State.setValue(CurrentStudyState.STUDY, originalStudyState);
    } finally {
      setIsAddingSite(false);
    }
  };

  const handleEditSite = (updatedSite) => {
    const updatedSites = sites.map((site) =>
      site.site_id === updatedSite.site_id ? updatedSite : site
    );
    setSites(updatedSites);
    if (onUpdateStudy) {
      onUpdateStudy({
        ...study,
        sites: updatedSites,
      });
    }
  };

  const handleDeleteSite = async (siteToDelete) => {
    const originalSites = [...sites];
    const originalStudy = { ...study };

    setIsDeletingSite(true);

    try {
      const response = await SiteController.deactivateSiteById(
        siteToDelete.site_id
      );

      if (!response || response?.success === false) {
        throw new Error(response?.message || "Unknown deletion error");
      }

      const updatedSites = sites.filter(
        (s) => s.site_id !== siteToDelete.site_id
      );
      setSites(updatedSites);
      if (onUpdateStudy) {
        onUpdateStudy({
          ...study,
          sites: updatedSites,
        });
      }
    } catch (error) {
      console.error("Error while deleting site:", error);

      const knownError = error?.message?.includes("Site cannot be deactivated");

      if (knownError) {
        setDeleteErrorMessage(
          "This site cannot be deleted because it is already linked to one or more participants. Please remove or reassign the participants before deleting this site."
        );
        setDeleteErrorModalOpen(true);
      } else {
        alert("Failed to delete the site. Please try again.");
        setSites(originalSites);
        if (onUpdateStudy) {
          onUpdateStudy(originalStudy);
        }
      }
    } finally {
      setIsDeletingSite(false);
    }
  };

  const handleReorderSites = (oldIndex, newIndex) => {
    const result = Array.from(sites);
    const [removed] = result.splice(oldIndex, 1);
    result.splice(newIndex, 0, removed);
    setSites(result);
    if (onUpdateStudy) {
      onUpdateStudy({
        ...study,
        sites: result,
      });
    }
  };

  const handlePreviewICF = async (site) => {
    const protocolId = site?.site_icf_id;
    const studyId = study.id;

    if (!protocolId) {
      console.error(
        "Erreur : ID du protocole ICF manquant pour l'aperçu.",
        site
      );
      alert("Impossible d'afficher l'ICF : ID du document manquant.");
      return;
    }
    console.log("ID du protocole ICF à afficher:", protocolId);
    console.log("ID de l'étude à afficher:", studyId);
    try {
      const displayResult = await StudyController.getProtocolDocumentAndDisplay(
        studyId,
        protocolId
      );
      if (!displayResult.success) {
        console.error(
          "Échec de l'affichage du protocole ICF:",
          displayResult.message
        );
        alert(`Impossible d'afficher l'ICF: ${displayResult.message}`);
      }
    } catch (error) {
      console.error("Erreur inattendue lors de l'aperçu de l'ICF:", error);
      alert("Une erreur inattendue s'est produite lors de l'aperçu de l'ICF.");
    }
  };

  const onChangeFile = async (e, item) => {
    console.log("=== e === SiteSettings.jsx === key: 545956 ===");
    console.dir(e, { depth: null, colors: true });
    console.dir(e.target?.files?.[0], { depth: null, colors: true });
    console.dir(item, { depth: null, colors: true });
    console.log("================================="); 
    
    if (e.target?.files?.[0]) {
      const confirmed = window.confirm(
        `Are you sure you want to update the protocol version file with "${e.target.files[0].name}"?`
      );
      
      if (confirmed) {
        setIsUploadingFile(true);
        await StudyController.updateProtocolVersionFile(
          {...item, study, selectedMasterICF},
          e.target.files[0]
        );
        setIsUploadingFile(false);
      } else {
        // Reset the file input if user cancels
        e.target.value = '';
        e.target.files = null;
        
        setIsUploadingFile(false);
      }
    }
  };

  const renderCell = (key, item, value, onChange, isEditing) => {
    if(isUploadingFile){
      return <div>Uploading...</div>;
    }
    
    if (key === "master_icf_version_name" && isEditing) {
      const currentIcfId =
        masterICFs.find((icf) => icf.master_icf_name === value)?.id || "";
      return (
        <select
          value={currentIcfId}
          onChange={(e) => {
            const selectedId = e.target.value;
            const selectedIcf = masterICFs.find((icf) => icf.id === selectedId);
            onChange(selectedIcf ? selectedIcf.master_icf_name : "");
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        >
          {masterICFs.map((icf) => (
            <option key={icf.id} value={icf.id}>
              {icf.master_icf_name}
            </option>
          ))}
        </select>
      );
    }
    if (key === "site_icf_file_name") {
      if (isEditing) {
        return (
          <div className="flex justify-center">
            <div className="relative">
              <Button variant="addbutton" className="px-4 py-2">
                Edit site ICF
              </Button>
              <input
                type="file"
                className="absolute inset-0 opacity-0 cursor-pointer"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    onChangeFile(e, item);
                  }
                }}
                accept=".pdf,.doc,.docx"
              />
            </div>
          </div>
        );
      } else {
        return (
          <div className="flex items-center">
            {item.site_icf_id ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handlePreviewICF(item);
                }}
                className="text-blue-600 hover:text-blue-800 flex items-center"
              >
                View ICF
              </a>
            ) : (
              <span>N/A</span>
            )}
          </div>
        );
      }
    }
    return isEditing ? (
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
      />
    ) : (
      <span>{value}</span>
    );
  };

  const columns = [
    { key: "master_icf_version_name", header: "Master ICF version", width: "25%" },
    { key: "site_name",               header: "Site name",          width: "25%" },
    { key: "site_address",            header: "Site address",       width: "30%" },
    { key: "site_icf_file_name",      header: "View site ICF",      width: "15%" },
  ];
  
  const filteredSites = selectedFilterICF
    ? sites.filter((s) => {
        if (s.master_icf_id) return s.master_icf_id === selectedFilterICF;
        const selected = masterICFs.find((i) => i.id === selectedFilterICF);
        return selected ? s.master_icf_version_name === selected.master_icf_name : false;
      })
    : sites;
  
  return (
    <div className={`bg-dashboard-bg1 rounded-xl p-4 sm:p-6 ${study.status === "closed" ? "pointer-events-none" : ""}`}>
      <FormSection title="Site settings">
        <div className="mb-6">
          <label className="mb-1 block text-sm font-medium text-gray-700">Select master ICF version</label>
          <select
            value={selectedFilterICF}
            onChange={handleFilterICFChange}
            className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF] sm:max-w-md"
          >
            {masterICFs.map((icf) => (
              <option key={icf.id} value={icf.id}>
                {icf.master_icf_name}
              </option>
            ))}
          </select>
        </div>
      </FormSection>
  
      <FormSection title="Site">
        {/* Robust horizontal scroll for tablet/screen-share */}
        <div className="-mx-3 sm:mx-0">
          <div className="overflow-x-auto px-3 sm:px-0" style={{ scrollbarGutter: "stable both-edges" }}>
          <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
              <EditableTable
                items={filteredSites}
                columns={columns}
                onEdit={handleEditSite}
                onDelete={handleDeleteSite}
                onReorder={handleReorderSites}
                emptyMessage="No sites have been recorded yet. They will appear in the table once added"
                saveModalTitle="Save site changes"
                saveModalMessage="You are about to save the modifications made to the sites. These changes will be applied to the study."
                cancelModalTitle="Discard site changes"
                cancelModalMessage="You are about to discard all modifications made to the sites."
                deleteModalTitle="Delete site"
                deleteModalMessage="You are about to permanently delete this site from the study."
                renderCell={renderCell}
              />
            </div>
          </div>
        </div>
      </FormSection>
  
      <FormSection title="Add site" className="rounded-lg p-4">
        <div className="mb-6 grid grid-cols-1 items-end gap-6 md:grid-cols-2">
          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">Select Master ICF Version</label>
            <select
              name="masterICFVersion"
              value={selectedMasterICF}
              disabled
              className="w-full cursor-not-allowed rounded-md border border-gray-300 bg-gray-100 px-3 py-2 text-gray-600"
            >
              {masterICFs
                .filter((icf) => icf.id === selectedMasterICF)
                .map((icf) => (
                  <option key={icf.id} value={icf.id}>
                    {icf.master_icf_name}
                  </option>
                ))}
            </select>
          </div>
  
          <div className="min-w-0">
            <FormInput
              label="Site Name"
              name="siteName"
              value={newSite.siteName}
              onChange={handleInputChange}
              placeholder="Site Name"
            />
          </div>
        </div>
  
        <div className="mb-6 grid grid-cols-1 items-end gap-6 md:grid-cols-2">
          <div className="min-w-0">
            <FormInput
              label="Site address"
              name="siteAddress"
              value={newSite.siteAddress}
              onChange={handleInputChange}
              placeholder="Street, Number, City, Postal Code, Country"
            />
          </div>
  
          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">Link to site ICF</label>
            {/* Stack on small screens to prevent overflow */}
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <input
                type="text"
                name="siteICFLink"
                value={newSite.siteICFLink}
                onChange={handleInputChange}
                placeholder="Site ICF link"
                className="min-w-0 flex-1 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
              />
              <div className="relative shrink-0">
                <Button variant="addbutton" className="w-full px-4 py-2 sm:w-auto">
                  Upload site ICF
                </Button>
                <input
                  type="file"
                  className="absolute inset-0 cursor-pointer opacity-0"
                  onChange={handleFileUpload}
                  accept=".pdf,.doc,.docx"
                />
              </div>
            </div>
          </div>
        </div>
  
        <Button onClick={handleAddSite} variant="addbutton" className="w-full sm:w-auto">
          Add site
        </Button>
      </FormSection>
  
      <Modal
        isOpen={deleteErrorModalOpen}
        onClose={() => setDeleteErrorModalOpen(false)}
        title="Cannot delete site"
        size="md"
      >
        <div className="p-4">
          <p className="text-gray-800">{deleteErrorMessage}</p>
          <div className="mt-4 flex justify-center">
            <Button variant="addbutton" onClick={() => setDeleteErrorModalOpen(false)}>
              Close
            </Button>
          </div>
        </div>
      </Modal>
  
      <Modal isOpen={isAddingSite} onClose={() => {}} title="Adding new site..." hideCloseButton size="md">
        <div className="flex flex-col items-center gap-4 p-6">
          <svg className="h-8 w-8 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="text-center">Please wait while we add the new site to your study.</p>
        </div>
      </Modal>
    </div>
  );
}
